import React from 'react';
import { Text } from '@mantine/core';
import './MetricTitle.css';

interface MetricTitleProps {
  title: string;
  metricId?: string;
  subtitle?: string;
  mb?: string | number;
  description?: string;
}

export const MetricTitle: React.FC<MetricTitleProps> = ({
  title,
  subtitle,
  mb,
  description,
}) => (
  <div className="metric-title" style={{ marginBottom: mb }}>
    <Text size="lg" fw={600} ta="left">
      {title}
    </Text>
    {subtitle && <p className="metric-title__subtitle">{subtitle}</p>}
    {description && (
      <Text size="xs" c="dimmed" title={description} component="span">
        ℹ️
      </Text>
    )}
  </div>
);
